// extracted by mini-css-extract-plugin
export var equalColumn = "_eu-0";